// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s zku\u0161enost", "%(count)s zku\u0161enosti", "%(count)s zku\u0161enost\u00ed"];
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prvn\u00ed a napi\u0161 hodnocen\u00ed";
